<template>
  <div
    v-if="algolia != null"
  >
    <ListContent
      :algolia="algolia"
    >
      <template v-slot:filters>
        <OrdersFilters/>
      </template>
      <template v-slot:listActionPanel>
        <ListActionPanel :isCheckable="false" :actions="panelActions">
        </ListActionPanel >
        <!-- <WrldListActionPanel :isCheckable="false" :actions="panelActions" :wrld="{ index: 'prod_transports_v2', pageSize: 20 }" /> -->
      </template>
      <template v-slot:list>
        <!-- <ais-configure
          :filters="customFilters"
        /> -->
        <ais-hits>
          <div
          v-if="items.length > 0"
          slot-scope="{ items }"
          >
            <ListItemCardBig
              v-for="item in items"
              :key="item.objectID"
              :color="computedOrderTypeColor(item)"
              :isCheckable="false"
              :resource="{...item, id: item.objectID}"
              @cardClicked="handleTransportSelect"
            >
              <!-- {{item.units}} -->
              <OrdersOverviewCard :order="item" />
            </ListItemCardBig>
          </div>
          <div v-else>
            {{ $t('orders.empty_orders') }}
          </div>
        </ais-hits>
      </template>
    </ListContent>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Auth } from '@/_services/amplify.service.js'
import ListItemCardBig from '@/components/wrld/generic/ListItemCardBig'
import ListContent from '@/components/wrld/generic/ListContent'
import ListActionPanel from '@/components/wrld/generic/ListActionPanel'
import OrdersOverviewCard from '@/components/orders/new/OrdersOverviewCard'
import OrdersFilters from '@/components/orders/new/OrdersFilters'
import WrldListActionPanel from '@/components/wrld/generic/WrldListActionPanel'
import { transportRequestService } from '@/_services'
export default {
  name: 'OrdersOverviewContent',
  components: {
    ListItemCardBig,
    ListContent,
    ListActionPanel,
    OrdersOverviewCard,
    OrdersFilters,
    WrldListActionPanel
  },
  props: {},
  data () {
    return {
      algolia: null
    }
  },
  computed: {
    ...mapGetters([
      'getCheckedOnPageCount',
      'getSelectedResource'
    ]),
    panelActions () {
      let icons = []
      icons.push(
        {
          icon: 'fas fa-plus',
          tooltip: this.$t('buttons.create'),
          // callback: this.$router.push({ name: 'TransportsCreate' }),
          callback: this.handleCreateNew,
          loading: false,
          iconSize: '14'
        }
      )
      icons.push(
        {
          icon: 'fas fa-dollar-sign',
          tooltip: this.$t('transport_request.create_transport_quote'),
          // callback: this.$router.push({ name: 'TransportsCreate' }),
          callback: this.handleCreateNewShipment,
          loading: false,
          iconSize: '14'
        }
      )
      return icons
    }
  },
  created() {
    Auth.currentSession().then((session) => {
      this.algolia = { indexName: 'prod_transports_v2',
        urlSync: true,
        searchParameters: {
          filters: `viewableBy:${session.getIdToken().payload.org}`
        } }
    })
  },
  methods: {
    ...mapActions({
      updateResource: 'updateResource',
      setTransportDetails: 'setTransportDetails'
    }),
    handleCreateNew() {
      this.$router.push({ name: 'TransportsCreate' })
    },
    handleCreateNewShipment() {
      this.$router.push({ name: 'TransportsCreateNewShipment' })
    },
    async handleTransportSelect(transportID) {
      if (this.getSelectedResource !== null) {
        this.setTransportDetails({ transportDetails: this.getSelectedResource })
        const transport = await transportRequestService.getTransport({ id: transportID })
        const resourceModifier = { // TODO: MOCKED
          createdAt: transport.createdAt,
          createdBy: 'SAP integration',
          lastUpdateAt: transport.updatedAt,
          lastUpdateBy: 'Bob Kennedy'
        }
        this.updateResource({ resource: { ...transport, objectID: transport.id, resourceModifier } })
        this.setTransportDetails({ transportDetails: transport })
      }
    },
    computedOrderTypeColor ({ type }) {
      switch (type) {
        case 'Transport':
          return '#00b4c4'
          break
        default:
          return '#c41000'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
